import React from "react";

const MainContainer = ({ children }) => (
  <div className="flex flex-col h-full overflow-hidden pt-4 px-0">
    <div className="flex flex-col h-full overflow-hidden">{children}</div>
  </div>
);

export default MainContainer;
